import { defineStore } from "pinia";
import { ref } from "vue";
import cookie from "js-cookie";

// We got these in URL search params
export const utmParams = [
  "utm_campaign",
  "utm_content",
  "utm_medium",
  "utm_source",
  "utm_term",
  "utm_internal",
  "crmterm",
  "crmcontent",
  "crmcampaign",
  "crmsource",
  "ab_split",
  "admitad_uid",
];

// Назначение config-driven A/B сплита, `<experimentId>:<variant>`.
const ASSIGNMENT_COOKIE = "ab_config_split";

export const useUTM = defineStore(
  "utm",
  () => {
    const initial = ref({});
    const current = ref({});

    // Analitics systems store it in cookies
    const trackIdParams = [
      "_ym_uid",
      "_fbp",
      "_ga",
      "_ttp",
      "ttclid",
      "_fbclid",
      "referer",
    ];

    // ---------- UTM ----------
    function setUTM(url) {
      // UTM Current
      current.value.link_parameters = url.search;
      utmParams.forEach((param) => {
        const value = url.searchParams.get(param);
        if (param === "ab_split") {
          // Контрольная арма config-сплита остаётся на своём URL: редиректа нет,
          // и параметр в адрес дописать некому. Назначение берём из cookie
          // `ab_config_split` — её сервер ставит обеим армам (server/utils/abSplit.ts).
          const assignment = value || cookie.get(ASSIGNMENT_COOKIE);
          if (assignment) current.value[param] = assignment;
          return;
        }
        if (param === "admitad_uid") {
          const uid = value || cookie.get("admitad_uid");
          if (uid) current.value[param] = uid;
          else delete current.value[param];
          return;
        }
        current.value[param] = value || " ";
      });

      // UTM Initial
      if (!initial.value.link_parameters) {
        initial.value.link_parameters = url.search;
        utmParams.forEach((param) => {
          initial.value[param] = url.searchParams.get(param);
        });
      }
    }
    // ---------- Tracking ----------
    const chatgptAdsParams = () => ({
      oppref:
        new URL(document.location.href).searchParams.get("oppref") ||
        cookie.get("__oppref") ||
        cookie.get("oppref"),
      obref: cookie.get("__obref"),
    });

    const setTracking = () => {
      const fbc = cookie.get("_fbc");
      if (fbc) {
        current.value["_fbclid"] = fbc;
        initial.value["_fbclid"] = fbc;
      }
      Object.entries(chatgptAdsParams()).forEach(([param, value]) => {
        if (!value) return;
        current.value[param] = value;
        if (initial.value[param] === undefined) initial.value[param] = value;
      });
      // Current tracking
      trackIdParams.forEach((param) => {
        const value = cookie.get(param);
        if (value) current.value[param] = value;
      });

      // Initial tracking
      trackIdParams.forEach((param) => {
        if (initial.value[param] === undefined) {
          initial.value[param] = cookie.get(param);
        }
      });
    };

    function init() {
      const url = new URL(document.location.href);
      setUTM(url);
    }

    function getCurrentParams() {
      setTracking();
      const formatted = { ...current.value };

      trackIdParams.forEach((param) => {
        const nameWoUnderscore = param.startsWith("_") ? param.slice(1) : param;

        switch (nameWoUnderscore) {
          case "ym_uid":
            formatted["ym_id"] = formatted[param];
            break;
          case "ttclid":
            formatted["ttclid_2"] = formatted[param];
            delete formatted["ttclid"];
            break;
          default:
            formatted[nameWoUnderscore] = formatted[param];
            if (nameWoUnderscore !== param) {
              delete formatted[param];
            }
            break;
        }
      });

      return formatted;
    }

    function getInitialParams() {
      setTracking();
      const params = initial.value;
      const formatted = {};
      const postfix = "_initial";

      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          formatted[`${key}${postfix}`] = params[key];
        }
      }

      trackIdParams.forEach((param) => {
        const paramWithPostfix = `${param}${postfix}`;
        const nameWoUnderscore = param.startsWith("_") ? param.slice(1) : param;
        const nameWithPostfix = `${nameWoUnderscore}${postfix}`;

        if (formatted[paramWithPostfix] !== undefined) {
          if (nameWithPostfix === "ym_uid_initial") {
            formatted["ym_id_initial"] = formatted[paramWithPostfix];
            delete formatted[paramWithPostfix];
          } else {
            formatted[nameWithPostfix] = formatted[paramWithPostfix];
            if (paramWithPostfix !== nameWithPostfix) {
              delete formatted[paramWithPostfix];
            }
          }
          if (nameWithPostfix === "ttclid_initial") {
            formatted["ttclid_2_initial"] = formatted["ttclid_initial"];
          }
        }
      });

      return formatted;
    }

    window.addEventListener("load", () => {
      setTracking();
    });

    return {
      initial,
      current,
      init,
      getCurrentParams,
      getInitialParams,
    };
  },
  {
    persist: {
      key: "autobooking_utm",
    },
  }
);